import { inject, InjectionToken } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { LoginService } from './core/services/login/login.service';
import { LoaderCssService } from './core/services/loader/loader-css.service';
import { ConfigurationStyles } from './core/models/configuration-styles.models';
import { EnvService } from './shared/services/env.service';


const IS_LOGGED_GUARD = (): boolean=>{
  const login = inject(LoginService);
  if(  login.isLoggedIn() ){
    return true;
  }
  const router = inject(Router);
  router.navigate(['/']);
  return false;

}
const HAS_PERMISSION_GUARD = (value: any) => {
  const login = inject(LoginService);
  if (login.userPermission?.includes(value.data.permission)) {
    return true;
  } else {
    const router = inject(Router);
    router.navigate(['/']);
    return false;
  }
}

const CONFIGURATION_STYLE = () => {
  const loaderCss = inject(LoaderCssService);
  const env = inject(EnvService);

  loaderCss.loadStyle(env.getConfigurationStyles().STYLE!);
}


export const routes: Routes = [
  {
    path: '',
    canActivateChild: [CONFIGURATION_STYLE],
    children: [
      // Rutas públicas
      {
        path: '',
        children: [
          { path: '', redirectTo: 'login', pathMatch: 'full' },
          { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
          { path: 'forgot-password', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
          { path: 'changepassword/:token', loadComponent: () => import('./pages/set-password/set-password.component').then(m => m.SetPasswordComponent) },
        ]
      },
      // Rutas privadas (requieren login)
      {
        path: '',
        canActivateChild: [IS_LOGGED_GUARD],
        children: [
          {
            path: 'fee',
            loadComponent: () => import('./pages/fee/fee.component').then(m => m.FeeComponent),
            canActivate: [HAS_PERMISSION_GUARD],
            data: { permission: 'fees' },
          },
          {
            path: 'home',
            loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
            canActivate: [HAS_PERMISSION_GUARD],
            data: { permission: 'fees' },
          },
          {
            path: 'help/user-manual',
            loadComponent: () => import('./pages/user-manual/user-manual.component').then(m => m.UserManualComponent),
            data: { permission: 'fees' },
          },
          {
            path: 'help/user-manual/:id',
            loadComponent: () => import('./pages/user-manual/manual-content/manual-content.component').then(m => m.ManualContentComponent)
          },
          {
            path: 'configuration/profile',
            loadComponent: () => import('./pages/configuration-profile/configuration-profile.component').then(m => m.ConfigurationProfileComponent),
            canActivate: [HAS_PERMISSION_GUARD],
            data: { permission: 'userManagement' },
          },
          {
            path: 'theme',
            loadComponent: () => import('./pages/theme/theme.component').then(m => m.ThemeComponent)
          }
        ]
      }
    ]
  },
  { path: '**', redirectTo: '/login' }
];
